import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { X } from 'lucide-react';
import { authAPI } from '../../services/api';
import LoadingSpinner from './LoadingSpinner';

const ChangePasswordModal = ({ onClose }) => {
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.new_password.length < 8) {
      toast.error('Neues Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }
    if (form.new_password !== form.confirm_password) {
      toast.error('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      await authAPI.changePassword(form.current_password, form.new_password);
      toast.success('Passwort erfolgreich geändert.');
      onClose();
    } catch (error) {
      toast.error(
        error.response?.data?.detail ||
          'Passwort konnte nicht geändert werden.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Passwort ändern</h2>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Schließen"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="current_password" className="form-label">
              Aktuelles Passwort
            </label>
            <input
              type="password"
              id="current_password"
              name="current_password"
              value={form.current_password}
              onChange={handleChange}
              className="form-input"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="new_password" className="form-label">
              Neues Passwort
            </label>
            <input
              type="password"
              id="new_password"
              name="new_password"
              value={form.new_password}
              onChange={handleChange}
              className="form-input"
              required
              minLength={8}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm_password" className="form-label">
              Neues Passwort bestätigen
            </label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              value={form.confirm_password}
              onChange={handleChange}
              className="form-input"
              required
              minLength={8}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-outline"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <LoadingSpinner size="small" /> : 'Speichern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
